import React, { useEffect, useRef, useState } from 'react'
import axios from '../../../../../services/axios'
import DynamicForm from '../../../../../components/DynamicForm'
import { Button } from '../../../../../components/UiElements'
import cloneFormView from './ClonePrpfileForm'
import productProfileLoadData from './dataMapping/loadProductProfile'
import shapeProfileLoadData from './dataMapping/loadShapeProfile'
import sectionsLoadData from './dataMapping/loadSections'

const OpenCloneProductProfileForm = ({ change }) => {
  const cloneFormRef = useRef(null)

  return (
    <DynamicForm
      ref={cloneFormRef}
      items={(defaultValues, value) => [
        {
          name: 'clone_profile',
          labelClassName: 'hidden',
          type: 'PopUp',
          module: CloneProductProfile,
          view: ({ show }) => (
            <Button
              type={'alt'}
              className={' !flex-row flex'}
              onClick={() => {
                show()
              }}
            >
              <div className={'flex flex-row gap-md'}>
                <span className={'font-icon-solid'}></span>
                Clone from other products
              </div>
            </Button>
          ),
          title: 'Clone Profile',
          innerClassName: 'w-[550px]',
          change: change,
        },
      ]}
      defaultValues={{}}
      size={'md'}
    />
  )
}
export { OpenCloneProductProfileForm }

const CloneProductProfile = ({ data, item, close }) => {
  const formRef = useRef(null)
  const [productList, setProductList] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    axios(`/products/`, 'GET').then((response) => {
      const list = response.contents
        ?.filter((item) => item?.sections?.length > 0)
        .map((item) => ({
          label: item.name,
          value: item.product_profile_id,
          product: item,
          sections: item.sections.length,
          variant: item.variant_name,
          pricing: item.pricing.id,
        }))
      formRef.current.setData({ productList: list })
      setProductList(list)
    })
  }, [])

  const saveData = async () => {
    const data = await formRef?.current?.getData()
    if (data) {
      setLoading(true)
      await axios(`/productProfiles/${data.profile}`, 'GET')
        .then(async (response) => {
          await item.change(productProfileLoadData(response), 'product_profile')
          await item.change(shapeProfileLoadData(response.shape_profile), 'shape_profile')
          await item.change(response.pricing?.id, 'pricing')
          await item.change(sectionsLoadData(response.shape_profile.sections), 'sections', {
            id: data.profile,
            list: sectionsLoadData(response.shape_profile.sections),
          })

          close()
        })
        .catch((error) => {
          console.log(error)
          setLoading(false)
        })

      //submit(data)
    }
  }
  return (
    <div className={'py-xl px-xl flex flex-col gap-md'}>
      {!productList && <div>Loading ...</div>}
      <DynamicForm ref={formRef} items={cloneFormView} size={'md'} />
      {/*defaultValues={{productList: productList}}*/}

      <div className={'pt-md flex flex-row gap-sm justify-end'}>
        <Button
          className={' !flex-row flex'}
          type={'alt'}
          onClick={() => {
            close()
          }}
        >
          <div className={'flex flex-row gap-md'}> Cancel</div>
        </Button>
        <Button
          className={' !flex-row flex'}
          disabled={loading}
          onClick={() => {
            saveData()
          }}
        >
          <div className={'flex flex-row gap-md'}> Clone Profile</div>
        </Button>
      </div>
    </div>
  )
}
